import React from 'react';
import './DashboardHeader.scss';

const DashboardHeaderLoading = () => {
  return (
    <div className="dashboard-header">
      <div className="heading-div" style={{ background: '#e8edf3' }} />
      <div
        className="service-cards-container"
        style={{
          minHeight: '120px',
          background: 'linear-gradient(90deg, #f1f5f9 25%, #e8edf3 50%, #f1f5f9 75%)',
          backgroundSize: '200% 100%',
          animation: 'cfc-shimmer 1.4s infinite',
        }}
      />
    </div>
  );
};

export default DashboardHeaderLoading;
